export default {
  loading: false,
  catalog: [],
  categories: [],
  categoriesOpen: [],
  filter: ''
}
